import SunbitApi from '../services/SunbitApi';
import {ICreds} from "../constants/models";
import StorageService from "../services/Storage";

declare const window: Window & { sunbitEnv: string };

export const checkIfUserSignedIn = async (): Promise<ICreds> => {

  const userToken = StorageService.get('userToken');
  const userName = StorageService.get('userName');

  if (userToken && userName) {
    try {

      // Verify creds are working
      SunbitApi.setToken(userToken);
      await SunbitApi.getAllianceData();
      return {userToken: userToken, userName: userName}
    } catch (e) {
    }
  }

  throw new Error('User is not authenticated');
}
